import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=489119a2&scoped=true"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489119a2",
  null
  
)

export default component.exports